import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { Building } from "src/components/shared-components/class/general-classes/building";

/**
 * Select plant list
 */
export const listBuilding = createFeatureSelector<Array<Building>>(
  AppSettings.KEY_BUILDINGS
);

/**
 * Select current selected plant
 */
export const selectedBuilding = createFeatureSelector<Building>(
  AppSettings.KEY_CURRENT_BUILDING
);
